import { ref } from 'vue'

export function useDebounce() {
  const timeoutId = ref<NodeJS.Timeout | null>(null)

  const debounce = <T extends (...args: any[]) => any>(
    func: T,
    wait: number = 300
  ) => {
    return (...args: Parameters<T>): void => {
      if (timeoutId.value) {
        clearTimeout(timeoutId.value)
      }

      timeoutId.value = setTimeout(() => {
        func(...args)
        timeoutId.value = null
      }, wait)
    }
  }

  return {
    debounce
  }
}
